import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

export const Sliders = () => {
	// --- USP Slider ---
	const uspElements = document.querySelector('.js-header-slider');
	uspElements && new Splide('.js-header-slider', {
		type: 'loop',     	// Standard sliding without loop or fade
		perPage: 1,       	// Display 1 slide per page on mobile
		perMove: 1,       	// Number of slides moved on "next" or "prev"
		pagination: false, 	// Hide pagination dots
		arrows: false, 			// Hide arrows
		autoplay: true, 		// Ste auto play to true on mobile 
		gap: 20,           	// Gap between slides in pixels
		arrows: false,     	// Hide navigation arrows
		mediaQuery: 'min',	// Use min-width in breakpoint calculations
		loop: true, 				// Enable looping to allow the USP's to continue
		breakpoints: {
			767: {
				perPage: 2, // Display 2 slides per page on tablets
			},
			1023: {
				perPage: 3, // Display 3 slides per page on larger tablets
				autoplay: false, // Disable autoplay where its not required
				type: 'slide', // Disable looping to remove excess DOM weight
			}
		},
	}).mount();

	// --- Logos Slider ---
	const logosElements = document.querySelector('.js-logo-slider');
	logosElements && new Splide('.js-logo-slider', {
		type: 'loop',
		drag: 'free',
		focus  : 'center',
		rewind: true,
		autoScroll: {
			pauseOnHover: false,
			pauseOnFocus: false,
			speed: 0.6,
		},
		perPage: 2, // Mobile 2 per page
		perMove: 1,
		pagination: false, // No Pagination due to arrows
		gap: 20, // Add 20px of gutter to the slides
		arrows: false, // Add the arrows in, these are controlled in the twig view
		mediaQuery: 'min', // Use min widths to calculate the breakpoints
		breakpoints: {
			767: {
				perPage: 3, // Load 4 slides for iPad and up
			},
			1023: {
				perPage: 4, // Load 6 slides for iPad pro and up
			},
			1279: {
				perPage: 6, // Load 8 slides for Laptop and up
				gap: 40, // Add 40px of gutter to the slides
			}
		}
	}).mount({ AutoScroll }); // Init the logos slider


	const CaseStudySliderElements = document.querySelector('.js-case-studies');
	CaseStudySliderElements && new Splide('.js-case-studies', {
			type: 'fade', // Make the banner slides fade
			arrows: true, // Disable arrows for the banner slider
			pagination: false, // Enable pagination for the banner slider
			keyboard: false, // Disable keybaord shortcuts to navigate the slider
			drag: false, // Disable mouse drag on the banner slider
			rewind: true, // Enable to allow infinate loop
			autoplay: true, // Enable autopplay for banners slider
			speed: 2500, // Speed of the transitions
			interval: 5000, // Set autplay time to 5s for the banners
			pauseOnHover: true, // Set to pause on hover of slide
			perPage: 1
	}).mount();

	
	const CardSliderElements = document.querySelectorAll('.js-card-slider');
	if (CardSliderElements.length) {
		CardSliderElements.forEach((element, key) => {
			if (element) {
				const CardSlider = new Splide(element, {
					type: 'fade', // Make the banner slides fade
					arrows: false, // Disable arrows for the banner slider
					pagination: false, // Enable pagination for the banner slider
					keyboard: false, // Disable keybaord shortcuts to navigate the slider
					drag: false, // Disable mouse drag on the banner slider
					rewind: true, // Enable to allow infinate loop
					autoplay: 'pause', // Enable autopplay for banners slider
					speed: 1000, // Speed of the transitions
					interval: 500, // Set autplay time to 5s for the banners
					perPage: 1,
				}).mount();

				const parent = element.parentElement;

				parent.addEventListener('mouseenter', (e) => {
					CardSlider.Components.Autoplay.play();
				});

				parent.addEventListener('mouseleave', (e) => {
					CardSlider.Components.Autoplay.pause();
				});
			}
		})
	}
}